import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect } from "@/components/common";

export const inRange = (at, from, to) => (!from || (at || "") >= from) && (!to || (at || "").slice(0, 10) <= to);

const STACK = "grid grid-cols-1 gap-3 min-[480px]:grid-cols-2 lg:flex lg:flex-wrap lg:items-end [&_input]:w-full [&_input]:min-w-0 [&_select]:block [&_select]:w-full lg:[&_input]:w-44 lg:[&_select]:w-44";

export function FilterBar({ children, onReset, testId, stacked = false }) {
  return (
    <div className={`po-card mb-4 p-4 ${stacked ? STACK : "flex flex-wrap items-end gap-3"}`} data-testid={testId}>
      {children}
      <Button variant="outline" size="sm" data-testid={`${testId}-reset`} onClick={onReset} className={stacked ? "mt-1 h-10 w-full min-[480px]:col-span-2 lg:mt-0 lg:h-9 lg:w-auto" : "h-9"}><RotateCcw className="mr-1 h-3.5 w-3.5" />Reset</Button>
    </div>
  );
}

export function SearchSelect({ label, value, onChange, options, testId, placeholder = "All" }) {
  return (
    <Field label={label}>
      <Input list={`${testId}-list`} data-testid={testId} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className="h-9 w-48" />
      <datalist id={`${testId}-list`}>{options.map((o) => <option key={o} value={o} />)}</datalist>
    </Field>
  );
}

export function Pick({ label, value, onChange, options, testId }) {
  return <Field label={label}><NativeSelect testId={testId} value={value} onChange={onChange} options={options} /></Field>;
}

export function DateRange({ from, to, onFrom, onTo, testId }) {
  return (
    <>
      <Field label="From"><Input type="date" data-testid={`${testId}-from`} value={from} onChange={(e) => onFrom(e.target.value)} className="h-9" /></Field>
      <Field label="To"><Input type="date" data-testid={`${testId}-to`} value={to} onChange={(e) => onTo(e.target.value)} className="h-9" /></Field>
    </>
  );
}
